import { Pageable, TaskResponse } from "@/apiGenerate/medserver";

export enum TaskStatus {
    Rename = 'Rename', 
    Settled = 'Settled',
    Pending = 'Pending'
}

export enum TaskPriorityType {
    None = 'None',
    NextDays = 'NextDays',
    EndOfShift = 'EndOfShift',
    DuringShift = 'DuringShift'
}

export interface TaskGroup {
    key: string;
    text: string;
    tasks: TaskResponse[];
    isResults: boolean;
    pageable: Pageable;
    totalCount: number;
}

export interface TaskPriorityChange {
    oldPriority: string;
    newPriority: string;
}

export interface TaskStatusChange {
    oldStatus: string;
    newStatus: string;
    taskPriority: string;
}
